import { createSlice } from "@reduxjs/toolkit";

import { Executor } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, Executor.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateExecutorsData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.EXECUTORS_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateExecutorsDataAction = globalStateExecutorsData.actions;
export const globalStateExecutorsDataReducer = globalStateExecutorsData.reducer;
export type globalStateExecutorsDataState = State;

export default globalStateExecutorsData;
